'use strict';

const scrollHelper = require('./modules/helpers/scroll');
const debounce = require('./modules/helpers/debounce');
const damHelper = require('./dam/dam-helper');
const productFilter = require('./product-filter');
const navigationScroller = require('./navigationScroller');

const $header = $('.js-header');
const $hamburgerBtn = $('.js-nav-toggle');
const $navWrapper = $('.js-navigation-inner');
const $navMobile = $('.js-nav-mobile');
const $navMobileFlyinLink = $navMobile.find('.js-mobile-flyin');
const navMobileLayerClass = '.js-nav-mobile-layer';
const navMobileAdditionalClass = '.js-nav-mobile-additional';
const $headerActionLinks = $('.js-header-actions');
const $headerLogo = $('.js-header-logo');
const $navDesktop = $('.js-nav-desktop');
const $navDesktopMainlink = $('.js-nav-desktop-item-link');
const navDesktopLayerClass = '.js-nav-desktop-layer';
const navDesktopOverlay = '.js-nav-desktop-overlay';
const navDesktopCloseBtnClass = '.js-close-desktop-nav';
const navDesktopCloseSubnavClass = '.js-close-desktop-subnav';
const navDesktopFirstLayerClass = '.js-nav-first-layer';
const scrollableMobClass = '> .js-mob-scrollable-container';
const scrollableDesktopClass = '> .js-nav-first-layer > .js-desktop-scrollable-container';
const scrollableDesktopSubnav = '> .js-desktop-scrollable-subcontainer';
const navDesktopScrollableParentClass = '.js-scrollable-parent';
const $navDesktopOpenLayer = $('.js-nav-desktop .js-nav-mobile-sublink');
const navMobileSublinkClass = '.js-nav-mobile-sublink';
const navDesktopSecLayerClass = '.js-nav-desktop-second-layer';
const navigateToMainSite = '.js-nav-to-main';

let isNavScrolling = false;

function addTouchEvents() {
    $('body').on('touchstart.navigation', function () {
        isNavScrolling = false;
    });

    $('body').on('touchmove.navigation', function () {
        isNavScrolling = true;
    });

    $('body').on('touchend.navigation', function () {
        isNavScrolling = false;
        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
    });

    $('.js-mob-scrollable-container').on('scroll.navigation', debounce(function () {
        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
    }, 100));
}

function removeTouchEvents() {
    $('body').off('touchstart.navigation');
    $('body').off('touchmove.navigation');
    $('body').off('touchend.navigation');
    $('.js-mob-scrollable-container').off('scroll.navigation');
}

//open mobile navigation
function toggleMobileNav() {
    $hamburgerBtn.on('click', function () {
        const $this = $(this);

        if (!$this.hasClass('active')) {
            $('body').css({
                'overflow': 'hidden'
            });

            addTouchEvents();

            $header.addClass('nav-active');
            $this.addClass('active');
            $navWrapper.addClass('active');
            $navMobile.stop().fadeIn(200).attr('aria-hidden', 'false');
            if ($(window).width() < 768) {
                $headerActionLinks.addClass('search-expand');
            }
            $headerLogo.attr('tabindex', '-1');

            $navMobileFlyinLink.parent().each(function (index, item) {
                setTimeout(function() {
                    $(item).addClass('flyin');
                }, index * 40);
            });
        } else {
            $('body').removeAttr('style');
            removeTouchEvents();
            closeMobileNavigation();
        }
    });

    $(document).on('keydown', function(e){
        if (e.which == 27 && $hamburgerBtn.hasClass('active')) {
            closeMobileNavigation();
        }
    });
}

function closeMobileNavigation() {
    $hamburgerBtn.removeClass('active');
    $navWrapper.removeClass('active');
    $navMobile.stop().fadeOut(200).attr('aria-hidden', 'true');
    $headerActionLinks.removeClass('search-expand');
    $headerLogo.removeAttr('tabindex').removeClass('fade-out');
    $navMobileFlyinLink.removeClass('flyin');
    $(navMobileLayerClass).removeClass('visible').fadeOut();
    $navMobile.find('li').removeClass('flyin').removeClass('flyout');
    $navMobile.find('a, button').removeAttr('tabindex');
    scrollHelper.enableScroll();
    $header.removeClass('nav-active');
}

//toggle different mobile layers
function toggleMobileNavLayers() {
    $('.js-mobile-nav-next-lvl').on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        if (e.cancelable !== false) {
            e.preventDefault();
        }

        if (!isNavScrolling) {
            const $this = $(this);
            const $parent = $this.parent();

            $this.addClass('js-selected-category');
            $parent.addClass('flyout');
            $parent.siblings().addClass('flyout');
            $this.attr('tabindex', '-1');
            $this.closest('.js-mob-scrollable-container').siblings('.js-nav-layer-back').attr('tabindex', '-1');
            $parent.siblings().find('.js-mobile-flyin').attr('tabindex', '-1');
            $parent.siblings().find('> .js-nav-mobile-sublink').attr('tabindex', '-1');
            $parent.siblings().find('> .js-mobile-nav-next-lvl').attr('tabindex', '-1');
            $(navMobileLayerClass).removeClass('js-visible');

            if (!$this.hasClass('js-skip-load-images')) {
                damHelper.updateImages($this.parent().find('.js-nav-responsive-bg').parent(), true);
            }

            $this.siblings(navMobileLayerClass).addClass('visible js-visible').attr('aria-hidden', 'false').fadeIn('fast', function () {
                const $visibleLayer = $(this);
                const $closestChild = $visibleLayer.find('ul').first().find('> li');
                const $siblingScrollable = $visibleLayer.find('.js-mob-scrollable-container');

                $siblingScrollable.scrollTop(0);

                $closestChild.each(function (index, item) {
                    setTimeout(function() {
                        $(item).addClass('flyin');
                    }, index * 40);
                });

                if ($(navMobileAdditionalClass).length) {
                    $(navMobileAdditionalClass).find('li').addClass('flyout');
                    $(navMobileAdditionalClass).find('li a').attr('tabindex', '-1');
                }

                gradientScrollCheck(navMobileLayerClass, scrollableMobClass);

                if ($parent.siblings().find(navMobileLayerClass).hasClass('visible')) {
                    $parent.siblings().find(navMobileLayerClass).removeClass('visible').hide();
                    $parent.siblings().find(navMobileLayerClass).find('.js-nav-mobile-subnav-item').removeClass('flyin').removeClass('flyout');
                    $parent.siblings().find('.js-nav-mobile-sublink, .js-nav-layer-back, .js-mobile-nav-next-lvl').removeAttr('tabindex');
                }
            });
        }

        setTimeout(() => {
            if ($('.js-nav-item.flyin.flyout').length) {
                $('.js-nav-layer-back').focus();
            } else {
                $('.js-nav-item.flyin:first').find('button').focus();
            }
        }, 750);
    });

    $('.js-nav-layer-back').on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        const $backBtn = $(this);
        const $parent = $backBtn.parent(navMobileLayerClass);

        $parent.removeClass('js-visible');
        $parent.find('ul').first().find('> li').removeClass('flyin');

        $parent.removeClass('visible').fadeOut('70', function () {
            const $closestList = $backBtn.closest('ul');
            const $closestListItem = $closestList.parent().find('> ul > li');
            const $additionalLinks = $closestList.siblings(navMobileAdditionalClass);

            $closestList.find('.js-selected-category').removeClass('js-selected-category');

            $closestList.find('> .js-nav-mobile-subnav-item').find('> .js-nav-mobile-sublink').removeAttr('tabindex');
            $closestList.find('> .js-nav-mobile-subnav-item').find('> .js-mobile-nav-next-lvl').removeAttr('tabindex');
            $closestList.parent('.js-mob-scrollable-container').siblings('.js-nav-layer-back').removeAttr('tabindex');

            if ($navMobile.find('.js-clicked').length) {
                const $clickedBanner = $navMobile.find('.js-clicked');
                const $backPanel = $clickedBanner.closest(navMobileLayerClass);

                $clickedBanner.siblings().each(function (index, item) {
                    setTimeout(function() {
                        $(item).removeClass('flyout');
                    }, index * 40);
                });
                $clickedBanner.siblings().find('> .js-nav-mobile-sublink').removeAttr('tabindex');
                $clickedBanner.siblings().find('> .js-mobile-nav-next-lvl').removeAttr('tabindex');
                $backPanel.find('> .js-nav-layer-back').removeAttr('tabindex');
                $clickedBanner.find('button').removeAttr('tabindex').focus();
                $clickedBanner.removeClass('js-clicked').removeClass('flyout');
            } else {
                $closestList.find('.js-mobile-flyin').removeAttr('tabindex');

                $closestListItem.each(function (index, item) {
                    setTimeout(function() {
                        $(item).removeClass('flyout');
                    }, index * 40);
                });

                if ($additionalLinks.length) {
                    $additionalLinks.find('li a').removeAttr('tabindex');
                }
            }

        }).attr('aria-hidden', 'true');

        $parent.parents(navMobileLayerClass).addClass('js-visible');

        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);

        setTimeout(() => {
            if (!$('.js-nav-item.flyin.flyout').length) {
                $('.js-nav-item.flyin:first').find('button').focus();
            } else {
                $('.js-nav-layer-back').focus();
            }
        }, 750);
    });
}

//check if gradient needs to be shown
function gradientScrollCheck(parentEl, scrollableElement) {
    $(parentEl).each(function () {
        if ($(this).hasClass('visible')) {
            const $visibleLayer = $(this);
            const $scrollableEl = $visibleLayer.find(scrollableElement);
            const $innerEl = $scrollableEl.find('> ul');
            const scrollableElTopPos = $scrollableEl.offset().top;
            const scrollableElTopPosCorrected = scrollableElTopPos - 5;
            const innerElTopPos = $innerEl.offset().top;

            if (innerElTopPos < scrollableElTopPosCorrected) {
                $visibleLayer.addClass('top-gradient');
            } else {
                $visibleLayer.removeClass('top-gradient');
            }

            const scrollableElHeight = $scrollableEl.outerHeight();
            const scrollableElBottomPos = scrollableElTopPos + scrollableElHeight + 10;
            const innerElHeight = $innerEl[0].scrollHeight;
            const innerElBottomPos = innerElHeight + innerElTopPos;

            if (innerElBottomPos > scrollableElBottomPos) {
                $visibleLayer.addClass('bottom-gradient');
            } else {
                $visibleLayer.removeClass('bottom-gradient');
            }
        }
    });
}

//check if content banner should be sticky
function stickyContentBanner(parentElement, scrollableEl) {
    $(document).find(parentElement).each(function () {
        const $visibleLayer = $(this);
        const $scrollableEl = $visibleLayer.find(scrollableEl);
        const $innerEl = $scrollableEl.find('> ul');
        const scrollableElTopPos = $scrollableEl.offset().top;
        const innerElTopPos = $innerEl.offset().top;
        const scrollableElHeight = $scrollableEl.outerHeight();
        const scrollableElBottomPos = scrollableElTopPos + scrollableElHeight - 26;
        const innerElHeight = $innerEl[0].scrollHeight;
        const innerElBottomPos = innerElHeight + innerElTopPos;
        const $visibleBanner = $visibleLayer.find('.js-navigation-content-banner');
        const visibleBannerHeight = $visibleBanner.outerHeight();

        if ($visibleBanner.length && innerElBottomPos < scrollableElBottomPos && $visibleLayer.hasClass('visible')) {
            $visibleLayer.addClass('sticky-content-banner');
            if (visibleBannerHeight > 116) {
                $innerEl.css('padding-bottom', visibleBannerHeight);
            } else {
                $innerEl.css('padding-bottom', '');
            }
        } else if ($visibleBanner.length && innerElBottomPos > scrollableElBottomPos && $visibleLayer.hasClass('visible')) {
            $visibleLayer.removeClass('sticky-content-banner');
            $innerEl.css('padding-bottom', '');
        }
    });
}

function mobileAccessibility() {
    $hamburgerBtn.on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            if ($('.js-header-actions').hasClass('search-expand')) {
                $('.js-search-input-toggle').focus();
            } else {
                $('.js-header-actions').find('li:last-child a').focus();
            }
        }
    });

    $('.js-open-minicart').on('keydown', function (e) {
        if ($('.js-navigation-inner').hasClass('active')) {
            if (e.which == 9 && !e.shiftKey) {
                e.preventDefault();
                $hamburgerBtn.focus();
            }
        }
    });

    $('.js-nav-layer-back').on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $hamburgerBtn.focus();
        }
    });

    $navMobile.find('li:last-child').find('> a').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            if ($(this).closest('ul').siblings(navMobileAdditionalClass).length) {
                $(navMobileAdditionalClass).find('li').first().find('a').focus();
            } else {
                $('.js-search-input-field').focus();
            }
        }
    });
}

//open first desktop nav layer
function desktopOpenNav() {
    $navDesktopMainlink.off('click');
    $navDesktopMainlink.on('click', function () {
        const $this = $(this);
        const closedNavigation = !$navDesktopMainlink.hasClass('selected');
        const $activeDropdown = $this.siblings(navDesktopLayerClass);
        const otherDropdown = $this.parent().siblings('.js-desktop-nav-item').find(navDesktopLayerClass);

        if (!$navDesktop.hasClass('copied-links')) {
            $navDesktop.addClass('copied-links');
            appendContentLinkPanel();
        }

        if (!$this.hasClass('selected')) {
            if (closedNavigation) {
                $this.addClass('selected');
                $navDesktop.addClass('active');
                $(navDesktopOverlay).fadeIn();
                $('body').css('overflow', 'hidden');

                $activeDropdown.stop().fadeIn(50, function () {
                    $activeDropdown.addClass('visible');
                    setTimeout(function() {
                        const $closestNavItem = $activeDropdown.find(navMobileSublinkClass);
                        $closestNavItem.each(function (index, item) {
                            setTimeout(function() {
                                $(item).addClass('flyin');
                            }, index * 40);
                        });
                        $activeDropdown.find(navDesktopCloseBtnClass).stop().fadeIn(1000);
                    }, 600);
                    setTimeout(function() {
                        $activeDropdown.addClass('opened');
                    }, 800);
                    gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);
                });
            } else {
                $navDesktopMainlink.removeClass('selected');
                $this.addClass('selected');

                otherDropdown.hide().removeClass('visible').removeClass('opened');
                otherDropdown.find(navMobileSublinkClass).removeClass('flyin');
                otherDropdown.find(navDesktopCloseBtnClass).hide();
                otherDropdown.find(navDesktopOverlay).hide();

                $activeDropdown.show().addClass('visible').addClass('opened');
                $activeDropdown.find(navDesktopCloseBtnClass).show();
                $activeDropdown.find(navDesktopOverlay).show();

                setTimeout(function() {
                    const $closestNavItem = $activeDropdown.find(navMobileSublinkClass);
                    $closestNavItem.each(function (index, item) {
                        setTimeout(function() {
                            $(item).addClass('flyin');
                        }, index * 40);
                    });
                }, 400);
                gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);

                $(navDesktopSecLayerClass).each(function () {
                    const $secondLayer = $(this);
                    if ($secondLayer.hasClass('opened')) {
                        $secondLayer.hide();
                        $(navDesktopFirstLayerClass).removeClass('first-opening');
                        $secondLayer.removeClass('slide-in').removeClass('opened').removeClass('visible');
                        $secondLayer.find(navDesktopScrollableParentClass).removeClass('visible');
                        $secondLayer.find(navDesktopCloseSubnavClass).hide();
                        $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
                        $secondLayer.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
                    }
                });
            }
        }
    });
}

//show second desktop layer
function desktopSubnavInit() {
    $('.js-nav-desktop-subbutton').on('click', function () {
        desktopOpenLayers($(this));
    });

    $('.js-nav-desktop-sublink').on('mouseenter', function () {
        desktopOpenLayers($(this));
    });

    $('.js-nav-mobile-sublink').each(function () {
        const $this = $(this);
        if (!$this.hasClass('js-nav-desktop-subbutton') && !$this.hasClass('js-nav-desktop-sublink')) {
            $this.on('click mouseenter', function () {
                desktopOpenLayers($this);
            });
        }
    });
}

function desktopOpenLayers(el) {
    const $this = el;
    if (!$this.hasClass('active')) {
        const $otherMainitems = $this.parent('.js-nav-mobile-subnav-item').siblings();

        if ($this.parent('.js-nav-mobile-subnav-item').find(navDesktopSecLayerClass).length) {
            $this.siblings(navDesktopSecLayerClass).find(navDesktopScrollableParentClass).addClass('visible');

            damHelper.updateImages($this.parent().find('.js-nav-responsive-bg').parent(), true);

            if (!$otherMainitems.find(navMobileSublinkClass).hasClass('active')) {
                $this.parents(navDesktopFirstLayerClass).addClass('first-opening');
                $this.siblings(navDesktopSecLayerClass).stop().fadeIn(10, function () {
                    const $activeLayer = $(this);

                    $activeLayer.addClass('slide-in');
                    setTimeout(function () {
                        $activeLayer.find(navDesktopCloseSubnavClass).fadeIn(300);
                        $activeLayer.addClass('opened');

                        $activeLayer.find('.js-nav-desktop-sublink-flyin').each(function (index, item) {
                            setTimeout(function() {
                                $(item).addClass('flyin');
                            }, index * 40);
                        });
                    }, 1000);

                    gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                    stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                });
            } else {
                $this.parents(navDesktopFirstLayerClass).removeClass('first-opening');
                $otherMainitems.find(navMobileSublinkClass).removeClass('active');
                $otherMainitems.find(navDesktopSecLayerClass).hide().removeClass('visible').removeClass('slide-in').removeClass('opened');
                $otherMainitems.find(navDesktopScrollableParentClass).removeClass('visible');
                $otherMainitems.find(navDesktopCloseSubnavClass).hide();
                $otherMainitems.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
                $this.siblings(navDesktopSecLayerClass).show().addClass('visible').addClass('opened');
                $this.siblings(navDesktopSecLayerClass).find(navDesktopCloseSubnavClass).show();
                gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);

                setTimeout(function() {
                    $this.siblings(navDesktopSecLayerClass).find('.js-nav-desktop-sublink-flyin').each(function (index, item) {
                        setTimeout(function() {
                            $(item).addClass('flyin');
                        }, index * 40);
                    });
                }, 100);
            }

            $this.addClass('active');
        } else {
            if ($otherMainitems.find(navMobileSublinkClass).hasClass('active')) {
                el.parents(navDesktopFirstLayerClass).find(navDesktopCloseBtnClass).fadeIn(300);
                el.parents(navDesktopFirstLayerClass).removeClass('first-opening');
                $otherMainitems.find(navMobileSublinkClass).removeClass('active');
                $otherMainitems.find(navDesktopSecLayerClass).hide().removeClass('visible').removeClass('slide-in').removeClass('opened');
                $otherMainitems.find(navDesktopScrollableParentClass).removeClass('visible');
                $otherMainitems.find(navDesktopCloseSubnavClass).hide();
                $otherMainitems.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
            }
        }
    }
}

//close desktop navigation
function desktopCloseNav() {
    $(navDesktopCloseBtnClass).on('click', function () {
        closeDesktopNavigation();
    });

    $(document).on('click', navDesktopCloseSubnavClass, function () {
        closeDesktopSubnavigation($(this));
    });

    $(document).on('keydown', function(e){
        if (e.which == 27 && $navDesktop.hasClass('active')) {
            closeDesktopNavigation();
        }
    });
}

function closeDesktopNavigation() {
    $(navDesktopOverlay).fadeOut();
    $navDesktopMainlink.removeClass('selected').addClass('disabled');
    $(navDesktopCloseBtnClass).hide();
    $(navDesktopLayerClass).removeClass('visible');
    $navDesktop.removeClass('active');
    scrollHelper.enableScroll();

    $(navDesktopSecLayerClass).each(function () {
        const $secondLayer = $(this);
        if ($secondLayer.hasClass('opened')) {
            $secondLayer.parents(navDesktopFirstLayerClass).addClass('first-opening');
            $secondLayer.removeClass('slide-in').removeClass('opened').removeClass('visible');
            $secondLayer.find(navDesktopScrollableParentClass).removeClass('visible');
            $secondLayer.find(navDesktopCloseSubnavClass).hide();
            $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
        }
    });

    setTimeout(function () {
        $navDesktopOpenLayer.removeClass('flyin');
        $(navDesktopLayerClass).stop().fadeOut(function () {
            $navDesktopMainlink.removeClass('disabled');
            $(navDesktopLayerClass).removeClass('opened');
            $(navDesktopSecLayerClass).hide();
            $(navDesktopFirstLayerClass).removeClass('first-opening');
        });
    }, 1000);
}

function closeDesktopSubnavigation(elem) {
    const $this = elem;
    const $firstLayer = $this.parents(navDesktopFirstLayerClass);
    const $secondLayer = $this.parents(navDesktopSecLayerClass);

    $firstLayer.addClass('first-opening');
    $this.hide();
    $this.parents(navDesktopScrollableParentClass).removeClass('visible');
    $secondLayer.removeClass('visible').removeClass('slide-in');
    $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
    $secondLayer.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
    $firstLayer.find(navMobileSublinkClass).addClass('disabled');
    setTimeout(function () {
        $firstLayer.find(navDesktopCloseBtnClass).fadeIn(400);
    }, 200);
    setTimeout(function () {
        $secondLayer.hide();
        $this.parents('.js-desktop-nav-item').find(navDesktopSecLayerClass).removeClass('opened');
        $firstLayer.removeClass('first-opening');
        $firstLayer.find(navMobileSublinkClass).removeClass('disabled');
    }, 1000);
}

function desktopAccessibility() {
    $navDesktopMainlink.on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey && $navDesktop.hasClass('active') && $(this).parent().is(':last-child') && !$(this).hasClass('selected')) {
            e.preventDefault();
            $(this).parent().siblings('.js-desktop-nav-item:first-child').find('.js-nav-desktop-item-link').focus();
        } else if (e.which == 9 && e.shiftKey && $navDesktop.hasClass('active') && $(this).parent().is(':first-child')) {
            e.preventDefault();
            $(this).parent().siblings('.js-desktop-nav-item:last-child').find('.js-nav-desktop-item-link').focus();
        }
    });

    $(navDesktopCloseBtnClass).on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey && $(this).parents('.js-desktop-nav-item').is(':last-child')) {
            e.preventDefault();
            $(this).parents('.js-desktop-nav-item').siblings('.js-desktop-nav-item:first-child').find('.js-nav-desktop-item-link').focus();
        }
    });

    $('.js-nav-desktop-sublink').on('keydown', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            desktopOpenLayers($(this));
        }
    });

    $('.js-desktop-scrollable-subcontainer').find('li:last-child .js-nav-desktop-tab').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $(this).parents(navDesktopScrollableParentClass).find(navDesktopCloseSubnavClass).focus();
        }
    });

    $(navDesktopCloseSubnavClass).on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(this).siblings('.js-desktop-scrollable-subcontainer').find('li:last-child .js-nav-desktop-tab').focus();
        }
    });
}

function navContentBanner() {
    $('.js-navigation-banner-simple').find('button').on('click', function () {
        if ($navDesktop.hasClass('active')) {
            $navDesktop.find('.js-nav-collection-button').click();
        } else {
            const $banner = $(this);
            const $parent = $banner.closest('li');
            const $collectionPanel = $navMobile.find('.js-nav-collection-button').siblings(navMobileLayerClass);

            $parent.addClass('flyout').addClass('js-clicked');
            $parent.siblings().addClass('flyout');
            $banner.attr('tabindex', '-1');
            $banner.closest('.js-mob-scrollable-container').siblings('.js-nav-layer-back').attr('tabindex', '-1');
            $parent.siblings().find('.js-mobile-flyin').attr('tabindex', '-1');
            $parent.siblings().find('> .js-nav-mobile-sublink').attr('tabindex', '-1');
            $parent.siblings().find('> .js-mobile-nav-next-lvl').attr('tabindex', '-1');
            $(navMobileLayerClass).removeClass('js-visible');

            damHelper.updateImages($collectionPanel.parent().find('.js-nav-responsive-bg').parent());

            $collectionPanel.addClass('visible').addClass('js-visible').attr('aria-hidden', 'false').fadeIn('fast', function () {
                const $visibleLayer = $(this);
                const $closestChild = $visibleLayer.find('ul').first().find('> li');

                $closestChild.each(function (index, item) {
                    setTimeout(function() {
                        $(item).addClass('flyin');
                    }, index * 40);
                });

                gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
            });
        }
    });
}

function appendContentLinkPanel() {
    $navDesktop.find('.js-nav-link-to-be-copied').each(function () {
        const $this = $(this);
        const $link = $this.parent('.js-nav-mobile-sublink');
        const linkText = $this.text();
        const linkHref = $link.attr('href');
        const placeholderText = $('.js-nav-content-links-placeholder').html();

        $link.parent().append(placeholderText);
        $link.siblings('.js-nav-desktop-second-layer').find('.js-nav-content-link-copied').text(linkText);
        $link.siblings('.js-nav-desktop-second-layer').find('.js-nav-content-link-copied').parents('.js-nav-desktop-tab').attr('href', linkHref);
    });
}

function onClickNavToMain() {
    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: '',
        },
        paragraphs: [
            {
                text: window.Resources.MODAL_LEAVE_CONFIRMATION_BODY
            }
        ],
        ctaHolder: {},
        buttons: [
            {
                type: 'btn',
                label: window.Resources.MODAL_LEAVE_CONFIRMATION_BUTTON_NO,
                eventName: 'onPrimaryButtonClick',
                shouldCloseModal: true
            }, {
                type: 'btn',
                label: window.Resources.MODAL_LEAVE_CONFIRMATION_BUTTON_YES,
                eventName: 'shouldProceed',
                shouldCloseModal: true
            }
        ],
        closeElement: {
            eventName: 'onCloseElementClick',
            shouldCloseModal: true
        },
        modalLarge: true,
        centerOnMobile: true
    });
}

function initializeEvents() {
    toggleMobileNav();
    toggleMobileNavLayers();
    mobileAccessibility();
    desktopOpenNav();
    desktopSubnavInit();
    desktopCloseNav();
    desktopAccessibility();
    navContentBanner();
    navigationScroller.init();

    $('.js-desktop-scrollable-container').on('scroll', function () {
        gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);
    });

    $('.js-desktop-scrollable-subcontainer').on('scroll', function () {
        gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
    });

    $(window).on('resize', function () {
        gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
        stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);
    });

    $(document).on('click', '.js-nav-desktop-subpanel-narow', function(e) {
        const $this = $(this);
        const url = $this.children('a')[0].href;
        const urlParts = url.split('#');
        if (urlParts[1]){
            e.stopPropagation();
            closeMobileNavigation();
            closeDesktopNavigation();
            const $productGridBlock = $('.js-product-grid-block');
            const collection = document.querySelector('[data-anchor-id=' + urlParts[1] + ']');
            if ($productGridBlock && collection){
                productFilter.changeTab(collection);
                $('html, body').animate({scrollTop: $productGridBlock.offset().top}, 800);
            }
        }
    });

    initNavigationToMainSite();
}

function initNavigationToMainSite() {
    if ($(navigateToMainSite).length > 0) {
        const navigateToMainSiteCTAs = $(navigateToMainSite); // CTA can exist in header and minicart
        let url = null;

        navigateToMainSiteCTAs.each(function(index, item) {
            const el = $(item);
            url = url || el.data('url');
            el.off('click').on('click', onClickNavToMain);
        });

        window.eventBus.$on('shouldProceed', function() {
            location.href = url || '/';
        });
    }
}

function updateNavigationLinksOnAddToCart(cartIsEmpty) {
    const $subNavItemsByCart = $('a.js-navigation-redirectbycart');
    if ($subNavItemsByCart.length > 0) {
        for (let index = 0; index < $subNavItemsByCart.length; index++) {
            const aItem = $subNavItemsByCart[index];
            const currentUrl = cartIsEmpty ? $(aItem).data('redirecturl') : $(aItem).data('originalurl');
            aItem.setAttribute('href', currentUrl);
        }
    }
}

const headerNavigation = {
    init: function() {
        initializeEvents();
    },
    initNavigationToMainSite: initNavigationToMainSite,
    updateNavigationLinksOnAddToCart: updateNavigationLinksOnAddToCart
};

module.exports = headerNavigation;
